import {
  Box, Container, Grid, Typography, styled,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FeatureUsageAction, FeatureUsageCard } from '../../modules/FeatureUsage';
import { MutedText } from '../../components/CustomTypography';
import { getFeatureUsage } from '../../features';
import { PackageHeader } from '../../components/CustomHeading';
import styles from '../../layouts/pages/style';
import useStyles from '../../hooks/useStyles';
import useFeatureUsage from './useFeatureUsage';

const HeaderSection = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.grey[0],
  padding: 10,
}));

function FeatureUsage({ dashboard, permissions }) {
  const classes = useStyles(styles)();
  const dispatch = useDispatch();
  const location = useLocation();
  const accountId = location.state?.accountId;
  const accountName = location.state?.accountName;

  const {
    filteredFeatures,
    siteWideLicense,
    totalSeats,
    dropDown,
    handlePinning,
    selectedFilters,
    handleFilterChange,
    getChartData,
    toggleAll,
    setToggleAll,
    refreshFeatureUsage,
  } = useFeatureUsage({ dashboard, accountId });

  useEffect(() => {
    if (selectedFilters?.featureUsageView) {
      dispatch(getFeatureUsage({ accountId, view: selectedFilters.featureUsageView }));
    }
  }, [selectedFilters?.featureUsageView, refreshFeatureUsage, accountId]);

  return (
    <Container maxWidth="xl">
      <Grid container gap={2}>
        <Grid item xs={12} className={classes.cardStyles}>
          <Box className={classes.headerStyles}>
            {(accountName || accountId) ? (
              <HeaderSection>
                <Typography variant="h4">
                  {`Feature Usage - ${accountName || accountId}`}
                </Typography>
              </HeaderSection>
            ) : (
              <HeaderSection>
                <PackageHeader noPackage heading="Feature Usage" />
                <MutedText text="Data of active accounts" />
              </HeaderSection>
            )}
          </Box>
        </Grid>

        <Grid item container xs={12} className={classes.cardStyles}>
          <FeatureUsageAction
            toggleAll={toggleAll}
            setToggleAll={setToggleAll}
            dropDown={dropDown}
            selectedFilters={selectedFilters}
            handleFilterChange={handleFilterChange}
          />
        </Grid>

        <Grid item xs={12}>
          <FeatureUsageCard
            data={filteredFeatures?.data}
            loading={filteredFeatures?.loading}
            error={filteredFeatures?.error}
            toggleAll={toggleAll}
            getChartData={getChartData}
            viewOption={selectedFilters.featureUsageView}
            siteWideLicense={siteWideLicense}
            totalActiveSeats={totalSeats}
            totalActiveAccounts={filteredFeatures?.totalActiveAccounts}
            handlePinning={handlePinning}
            dashboard={dashboard}
            permissions={permissions}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default FeatureUsage;
